import { motion } from 'framer-motion';
import { Mail, Clock, MessageCircle, CheckCircle, ArrowRight } from 'lucide-react';
import { useParams } from 'react-router-dom';

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '34607282943';

export default function ThankYouPage() {
  const { caseId } = useParams();

  const whatsappMsg = `Ola, acabei de submeter meu caso no LEGISLAI (ID ${caseId || ''}). Gostaria de saber mais sobre os proximos passos.`;
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(whatsappMsg)}`;

  return (
    <div className="min-h-screen bg-[#050608] flex items-center justify-center px-6" data-testid="thankyou-page">
      <div className="max-w-lg w-full">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-10"
        >
          <img
            src="/assets/logo-legislai.png"
            alt="FORTUNATO LEGISLAI"
            className="h-14 w-auto mx-auto"
          />
        </motion.div>

        {/* Success icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 200, delay: 0.2 }}
          className="flex justify-center mb-8"
        >
          <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[#C9A24A]/20 to-[#C9A24A]/5 flex items-center justify-center border border-[#C9A24A]/30">
            <CheckCircle className="w-12 h-12 text-[#C9A24A]" />
          </div>
        </motion.div>

        {/* Main message */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="text-center mb-10"
        >
          <h1 className="font-['Playfair_Display'] text-3xl md:text-4xl text-white mb-4">
            Obrigado!
          </h1>
          <p className="text-gray-400 text-lg leading-relaxed">
            Seu caso foi submetido com sucesso. Nosso motor de IA esta analisando suas informacoes agora.
          </p>
        </motion.div>

        {/* Info cards */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="space-y-4 mb-10"
        >
          <div className="flex items-start gap-4 bg-black/40 border border-[#C9A24A]/15 p-5" data-testid="info-email">
            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-[#C9A24A]/10 rounded">
              <Mail className="w-5 h-5 text-[#C9A24A]" />
            </div>
            <div>
              <h3 className="text-white font-medium mb-1">Diagnostico por Email</h3>
              <p className="text-gray-500 text-sm">
                Recebera o diagnostico completo no seu email em <strong className="text-[#C9A24A]">3 a 5 minutos</strong>. Se nao encontrar na caixa de entrada, verifique o <strong className="text-white">spam</strong>.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 bg-black/40 border border-[#00D4FF]/15 p-5" data-testid="info-time">
            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-[#00D4FF]/10 rounded">
              <Clock className="w-5 h-5 text-[#00D4FF]" />
            </div>
            <div>
              <h3 className="text-white font-medium mb-1">O Que Esta Incluido</h3>
              <p className="text-gray-500 text-sm">
                Relatorio com rotas legais, checklist documental, cronograma de acoes, analise de riscos e fontes oficiais verificadas.
              </p>
            </div>
          </div>

          {caseId && (
            <div className="text-center pt-2">
              <span className="text-gray-600 text-xs">ID do Caso: </span>
              <span className="text-[#C9A24A] text-xs font-mono">{caseId}</span>
            </div>
          )}
        </motion.div>

        {/* WhatsApp CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
          className="text-center"
        >
          <p className="text-gray-500 text-sm mb-4">Duvidas? Fale diretamente com nosso especialista:</p>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#25D366] text-white font-semibold uppercase tracking-wider text-sm hover:bg-[#20BD5A] transition-colors"
            data-testid="whatsapp-cta"
          >
            <MessageCircle className="w-5 h-5" />
            Falar no WhatsApp
          </a>
        </motion.div>

        {/* Footer */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          className="text-center mt-12"
        >
          <p className="text-gray-700 text-xs">
            O FORTUNATO LEGISLAI utiliza IA para buscar e analisar informacoes da Extranjeria de Espanha e fontes oficiais da UE.
          </p>
        </motion.div>
      </div>
    </div>
  );
}
